import { render, staticRenderFns } from "./nav-top-tag.vue?vue&type=template&id=d09ed5e8&"
import script from "./nav-top-tag.vue?vue&type=script&lang=js&"
export * from "./nav-top-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports